const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl } = wp.components;
import SelectBackground from '../wp-controlers/select-background';
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    containerized,
    imagePosition,
    withFigcaption,
    variant,
    contentPosition,
    titleFull,
    titleAfterImage,
    padding,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <SelectControl
          label="Selecione a posição do conteúdo"
          title="Selecione a posição do conteúdo"
          value={contentPosition}
          options={[
            { label: 'Direita', value: 'right' },
            { label: 'Esquerda', value: 'left' },
          ]}
          onChange={(position) => setAttributes({ contentPosition: position })}
        />

        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            { label: 'Horizontal', value: 'horizontal' },
            { label: 'Vertical', value: 'vertical' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <SelectBackground
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <ToggleControl
          label="Adicionar container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <ToggleControl
          label="O primeiro título irá ocupar a seção toda ?"
          checked={titleFull}
          onChange={() => setAttributes({ titleFull: !titleFull })}
        />

        <ToggleControl
          label="Colocar o título em mobile abaixo da imagem"
          checked={titleAfterImage}
          onChange={() => setAttributes({ titleAfterImage: !titleAfterImage })}
        />

        <SelectControl
          label="Padding deste container"
          title="Padding deste container"
          value={padding}
          options={[
            { label: 'Nenhum', value: 'none' },
            { label: 'Pequeno', value: 'small' },
            { label: 'Médio', value: 'medium' },
            { label: 'Grande', value: 'large' },
          ]}
          onChange={(position) => setAttributes({ padding: position })}
        />
      </PanelBody>

      <PanelBody title="Atributos da imagem" initialOpen={true}>
        <ImageControl
          image="sideImage"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <SelectControl
          label="Selecione a posição da imagem"
          title="Selecione a posição da imagem"
          value={imagePosition}
          options={[
            { label: 'Topo', value: 'imageTop' },
            { label: 'Centro', value: 'imageCenter' },
            { label: 'Baixo', value: 'imageBottom' },
          ]}
          onChange={(position) => setAttributes({ imagePosition: position })}
        />

        <ToggleControl
          label="Adicionar figcaption para o mobile?"
          checked={withFigcaption}
          onChange={() => setAttributes({ withFigcaption: !withFigcaption })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
